import { BlockTemplate, ClientRouteBlock, REF_KEY, ReferenceProps } from '@common/model/blocks';
import { useMemo } from 'react';
import { blocksConfig } from '../lib/config';
import { useBlockDictionary } from './useBlockDictionary';

export const useBlockRender = (innerBlock?: ClientRouteBlock) => {
  const mutationOfTaponyms = useBlockDictionary();

  const props = useMemo(() => {
    if (!innerBlock) {
      return null;
    }
    if (innerBlock.block.template === BlockTemplate.reference) {
      const innerProps = innerBlock.innerBlocks?.[0]?.block.props;
      if (!innerProps) {
        throw new Error('Something went wrong');
      }

      const { shortcodes } = innerBlock.block.props[REF_KEY] as ReferenceProps;
      return mutationOfTaponyms(innerProps, shortcodes);
    }

    return mutationOfTaponyms(innerBlock.block.props);
  }, [innerBlock, mutationOfTaponyms]);

  const Render = useMemo(() => {
    if (!innerBlock) {
      return null;
    }
    if (innerBlock.block.template === BlockTemplate.reference) {
      const template = innerBlock.innerBlocks?.[0]?.block.template;
      if (!template) {
        throw new Error('Something went wrong');
      }
      return blocksConfig[template];
    }
    return blocksConfig[innerBlock.block.template];
  }, [innerBlock]);

  return { props, Render };
};
